export class Alfatron21e {
    constructor(socket, log) {
        this.socket = socket;
        this.autoSwitch = '1';
        this.firmwareVersion = '1.0.1';
        this.videoOutput = 'H';
        this.asyncHandlers = [
            {
                name: 'getAutoSwitch',
                regExp: /#GET_AUTO_SWITCH/i,
                callback: (match) => {
                    this.socket.send(`@AUTO_SWITCH ${this.autoSwitch}`);
                },
            },
            {
                name: 'setAutoSwitch',
                regExp: /#SET_AUTO_SWITCH\s+(\d)/i,
                callback: (match) => {
                    this.autoSwitch = match[1];
                    this.socket.send(`@AUTO_SWITCH ${this.autoSwitch}`);
                },
            },
            {
                name: 'getFirmware',
                regExp: /#GET_FIRMWARE_VERSION/i,
                callback: (match) => {
                    this.socket.send(`@V${this.firmwareVersion}`);
                },
            },
            {
                name: 'getVideo',
                regExp: /#GET_AV/i,
                callback: (match) => {
                    this.socket.send(`@AV ${this.videoOutput}`);
                },
            },
            {
                name: 'setVideo',
                regExp: /#SET_AV (C|H)/i,
                callback: (match) => {
                    this.videoOutput = match[1];
                    this.socket.send(`@AV ${this.videoOutput}`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`COMMAND ERROR`);
                },
            },
        ];
    }
}
Alfatron21e.emulatorType = 'socketEmulator';
Alfatron21e.key = '-MZNW9MS_bzl8bKlpSvl';
